(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2scent-product-enhancements"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-two-scent-enhancements]').forEach((section) => {
    const dataNode = section.querySelector('[data-two-scent-product]');
    if (!dataNode) return;

    let currentProduct;
    try {
      currentProduct = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const productForm = forms.find((form) => form.closest('#MainContent'));
    const originalButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
    const paymentPanel = section.querySelector('[data-two-scent-payment-panel]');

    if (productForm && paymentPanel) {
      productForm.insertAdjacentElement('afterend', paymentPanel);
    }

    const sticky = section.querySelector('[data-two-scent-sticky]');
    const stickyButton = section.querySelector('[data-two-scent-sticky-button]');
    if (sticky && stickyButton && productForm && originalButton) {
      sticky.hidden = false;
      stickyButton.disabled = originalButton.disabled;
      const observer = new IntersectionObserver(
        ([entry]) => {
          sticky.style.display = entry.isIntersecting ? 'none' : 'flex';
        },
        { threshold: 0.15 }
      );
      observer.observe(originalButton);

      stickyButton.addEventListener('click', () => {
        if (!originalButton.disabled) productForm.requestSubmit(originalButton);
      });

      productForm.addEventListener('change', () => {
        window.setTimeout(() => {
          stickyButton.disabled = originalButton.disabled;
          const visiblePrice = document.querySelector('[data-block-type="price"] .price, .product-details .price');
          const stickyPrice = section.querySelector('[data-two-scent-sticky-price]');
          if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
        }, 80);
      });
    }

    const storageKey = 'two-scent-recent-products';
    let recentProducts = [];
    try {
      recentProducts = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(recentProducts)) recentProducts = [];
    } catch (error) {
      recentProducts = [];
    }

    const previousProducts = recentProducts.filter((item) => item.handle !== currentProduct.handle).slice(0, 4);
    const recentSection = section.querySelector('[data-two-scent-recent]');
    const recentGrid = section.querySelector('[data-two-scent-recent-grid]');

    previousProducts.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'two-scent-recent__card';
      card.href = item.url;

      const media = document.createElement('span');
      media.className = 'two-scent-recent__media';
      const image = document.createElement('img');
      image.className = 'two-scent-recent__image';
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      media.append(image);

      const title = document.createElement('span');
      title.className = 'two-scent-recent__title';
      title.textContent = item.title;
      const price = document.createElement('span');
      price.className = 'two-scent-recent__price';
      price.textContent = item.price;
      card.append(media, title, price);
      recentGrid?.append(card);
    });

    if (previousProducts.length && recentSection) recentSection.hidden = false;

    const nextHistory = [currentProduct, ...recentProducts.filter((item) => item.handle !== currentProduct.handle)].slice(0, 8);
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(nextHistory));
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fragrance-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fragrance-finder]').forEach((root)=>{const cards=[...root.querySelectorAll('[data-grid] .ff-card')],filters=[...root.querySelectorAll('[data-filter]')],count=root.querySelector('[data-count]'),empty=root.querySelector('[data-empty]');const match=(card,key,value)=>!value||(key==='family'||key==='occasion'||key==='season'?card.dataset[key].split('|').includes(value):card.dataset[key]===value);const apply=()=>{let n=0;cards.forEach((card)=>{const show=filters.every((filter)=>match(card,filter.dataset.filter,filter.value));card.hidden=!show;if(show)n+=1;});count.textContent=String(n);empty.hidden=n!==0;};filters.forEach((filter)=>filter.addEventListener('change',apply));root.querySelector('[data-reset]').addEventListener('click',()=>{filters.forEach((filter)=>{filter.value='';});apply();});root.querySelector('[data-find]').addEventListener('click',()=>{const answers={};root.querySelectorAll('[data-quiz]').forEach((input)=>{answers[input.dataset.quiz]=input.value;});const scored=cards.map((card)=>{let score=0;Object.entries(answers).forEach(([key,value])=>{if(value&&match(card,key,value))score+=1;});return{card,score};}).sort((a,b)=>b.score-a.score).slice(0,4);root.querySelector('[data-quiz-grid]').replaceChildren(...scored.map((item)=>item.card.cloneNode(true)));const results=root.querySelector('[data-quiz-results]');results.hidden=false;results.scrollIntoView({behavior:'smooth',block:'start'});});apply();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
